import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { AreaChart } from '@/components/charts/AreaChart';
import { useRevenueData } from '@/hooks/useAdminBilling';

export function RevenueChart() {
  const { data: rawData } = useRevenueData('12m');
  const data = rawData as Record<string, unknown> | undefined;
  const mrrHistory = (Array.isArray(data?.mrrHistory) ? data.mrrHistory : []) as Array<{ month: string; mrr: number }>;
  const chartData = mrrHistory.map((d) => ({
    date: d.month,
    mrr: d.mrr,
  }));

  return (
    <Card>
      <CardHeader title="Evolution du MRR" />
      <CardContent>
        <AreaChart
          data={chartData}
          areas={[{ key: 'mrr', color: '#3b82f6', label: 'MRR' }]}
          height={300}
        />
      </CardContent>
    </Card>
  );
}
